import moment from "moment";

export default class LicenceAmountChange {
    constructor(raw = {}) {
        this.amount = raw.amount;
        this.date = raw.date;
        this.reason = raw.reason;
    }

    get colorForReason() {
        switch (this.reason) {
            case "BUY":
                return "indigo";
            case "CANCEL":
                return "red";
            case "ASSIGN":
                return "blue";
            case "DROPPED":
                return "red";
            case "MANUAL":
                return "purple";
            default:
                return "purple";
        }
    }

    get isAssignment() {
        switch (this.reason) {
            case "BUY":
                return false;
            case "CANCEL":
                return false;
            case "ASSIGN":
                return true;
            case "DROPPED":
                return true;
            case "MANUAL":
                return false;
            default:
                return false;
        }
    }

    get textForReason() {
        switch (this.reason) {
            case "BUY":
                return "Gekauft";
            case "CANCEL":
                return "Abgebrochen";
            case "ASSIGN":
                return "Vergeben";
            case "DROPPED":
                return "Entzogen";
            case "MANUAL":
                return "Manuell";
            default:
                return "Anderes";
        }
    }

    get dateMoment() {
        return moment(this.date);
    }
}
